export default __webpack_public_path__ + "static/media/CV_Rocco_Luigi_Scarcella.234c6816.pdf";